import axios from 'axios'
import {saveAs} from 'file-saver'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const BASE_TRADERULE_URL = `${BASE_URL}api/tradeRules/`;
const BASE_REPORTING_URL = `${BASE_URL}api/reporting/`;

const ReportingService = () => ({

    getAllTradeRuleCourseList: async (providerId) => {
        const { data } = await axios.get(`${BASE_TRADERULE_URL}GetAllTradeRuleCourseList/`+providerId);
        return data;
    },

    getSoldAndUnsoldTradeRoundReport: async (filters,providerId) => {   
        var reportdate = new Date();
        var reportName = `${reportdate.getUTCFullYear()}-${reportdate.getUTCMonth()}-${reportdate.getUTCDate()} ${reportdate.getUTCHours()}:${reportdate.getUTCMinutes()}:${reportdate.getUTCSeconds()}`
        var fileName = 'SoldvsUnsold_TradeRounds ' + reportName             
        const response = await axios.get(`${BASE_REPORTING_URL}${providerId}/TradeRuleReport?`+filters,{responseType: 'blob'});        
        const {data, headers} = response;
        saveAs(data, fileName);
    },
    
    getSoldTradeRoundReport: async (filters,providerId) => {    
        
        var reportdate = new Date();
        var reportName = `${reportdate.getUTCFullYear()}-${reportdate.getUTCMonth()}-${reportdate.getUTCDate()} ${reportdate.getUTCHours()}:${reportdate.getUTCMinutes()}:${reportdate.getUTCSeconds()}`
        var fileName = 'Sold_TradeRounds ' + reportName
        const response = await axios.get(`${BASE_REPORTING_URL}${providerId}/SoldTradeRoundsReport?`+filters,{responseType: 'blob'});    
        const {data, headers} = response;
        saveAs(data, fileName);
    },

    getBankingAndReAllocationsReport: async (filters,providerId) => {        
        var reportdate = new Date();
        var reportName = `${reportdate.getUTCFullYear()}-${reportdate.getUTCMonth()}-${reportdate.getUTCDate()} ${reportdate.getUTCHours()}:${reportdate.getUTCMinutes()}:${reportdate.getUTCSeconds()}`
        var fileName = 'BankingAndReAllocations ' + reportName
        const response = await axios.get(`${BASE_REPORTING_URL}${providerId}/BankingAndReAllocationsReport?`+filters,{responseType: 'blob'});    
        const {data} = response;
        saveAs(data, fileName);
    },
    
    getAllTradeRuleList: async  (providerId,filters) => {
        
        const { data } = await axios.get(`${BASE_TRADERULE_URL}${providerId}/GetAllActiveTradeRuleNames?`+filters);
        return data;
    },
});

export default ReportingService;